const ENV = process.env.REACT_APP_ENV;
const API_URL = process.env.REACT_APP_API_URL;


export {
    ENV,
    API_URL
};